import { useRef, useState, useEffect, useCallback, useContext } from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { Subject } from 'rxjs';
import { v4 } from 'uuid';
import * as turf from "@turf/turf";
mapboxgl.accessToken = 'pk.eyJ1IjoicGt0MWRldmVsb3BlciIsImEiOiJjbDZ6OXVjbzgwMmFrM3BsY3FweGkyYWJzIn0.r8Iu1ZteE0WwYt1LFfT1yg';
const UsemapMonitor = (Recolectores, socket,guardarcoordenada, Editarreco, Recolectorselecionado, SeleccionarReco, PeticionesMapa, rutareco, rutaencurso, DataZonaUsuario, Zoom,Sucursales, GeoJsonZona, TipoMapa) => {

    let RecolectorSelected = Recolectorselecionado;
    // CORDENADA INICIAL DE MAPA
    const [puntoinicial, setpuntoinicial] = useState(JSON.parse(localStorage.getItem('coordenadamapa')));

    // VARIABLE ACTIVADO
    const [isTabActive, setIsTabActive] = useState(true);
    const [isInactive, setIsInactive] = useState(false);
    const [Activado, setActivado] = useState()
    // REFERENCIAS
    const mapaDiv = useRef();
    const SucursalesIcon= useRef({});
    const [cordsdata, setcordsdata] = useState()
    const [geoJsonZona, setgeoJsonZona] = useState()
    const [VistaAgregarNuevaZona, setVistaAgregarNuevaZona] = useState("false")


   

    const HAndlerSelectedReco = (data) => {

    }


    let inactivityTime = 30 * 60 * 1000; // = 30min.
    let timeoutId;

    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsTabActive(!document.hidden);
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    const resetTimer = () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(setInactive, inactivityTime);
    };
    const setInactive = () => {
        setIsInactive(true);
        window.location.reload()
        // EJECUTAR MODAL DE INACTIVIDAD Y REFRESH

    };
    useEffect(() => {
        document.addEventListener('mousemove', resetTimer);
        document.addEventListener('mousedown', resetTimer);
        document.addEventListener('keypress', resetTimer);
        document.addEventListener('touchmove', resetTimer);
        timeoutId = setTimeout(setInactive, inactivityTime);
        return () => {
            document.removeEventListener('mousemove', resetTimer);
            document.removeEventListener('mousedown', resetTimer);
            document.removeEventListener('keypress', resetTimer);
            document.removeEventListener('touchmove', resetTimer);
            clearTimeout(timeoutId);
        };
    }, []);

    // EFECTOS PRINCIPALES PARA INACTIVIDAD Y REFRESH
    // EFECTO QUE RENUDAR LA CONEXION SIMPRE Y CUANDO SE CAMBIE LA PESTAÑA
    useEffect(() => {

        if (isTabActive) {
            // Reanudar actualizaciones en tiempo real
            if (!socket) return;
            if (!socket) return;
            socket.on("ActivePickers", (recosEntrentes) => {
         
                recosEntrentes?.map((res, index) => {
                
                    HandlerChangueColor(res.status, res.id)
                })
            });
            setTimeout(() => {
            }, 2500);
        } else {
            // Cuando no este activo
        }
    }, [isTabActive]);

    // FUNCION PARA AÑADIR MAPÄ
    const mapa = useRef();
    const [ coords, setCoords ] = useState( puntoinicial );
    const [iszonaclick, setiszonaclick] = useState(false)
    const setRef = useCallback((node) => {
        mapaDiv.current = node;
    }, []);

    useEffect(() => {
        const map = new mapboxgl.Map({
            container: mapaDiv.current,
            style: 'mapbox://styles/mapbox/outdoors-v12?optimize=true',
            center: [-102.6012034945277, 24.007726083194417],
            zoom: Zoom,
            minZoom: Zoom,
            //evita mover mapa
            // dragPan: false

        });
        mapa.current = map;

        return () => {
            if (mapa.current) {
                mapa.current.remove();
            }
          };
    }, []);
// }, [puntoinicial]);


    // AÑADIR RECOLECTORES AL MAPA
    const marcadores = useRef({});
    const nuevoMarcador = useRef(new Subject());
    var test = new Array;

    const AgregarMarcador = useCallback((ev, id) => {
        const { lng, lat } = ev.lngLat || ev;
        const RecoIcon = document.createElement('div');
        RecoIcon.className = `RecoiconoMapa`;
        const marker = new mapboxgl.Marker(RecoIcon);
        const popupPeticionesReco = new mapboxgl.Popup({ offset: 25 }).setHTML(
            `
            <div class='ContainerCardRecoMapa'>
                  <div class='ContainerImagenRecoMapa'>
                    <img src="data:image/png;base64,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"></img>
                  </div>
                  <div class='ContainerTextoReco'>
                    <p>${ev.name}</p>
                  </div>
              </div>
            `
        );
        marker.id = ev.id ?? v4();
        if (!marcadores.current[id]) {
            marker
                .setLngLat([lng, lat])
                .addTo(mapa.current)
                .setPopup(popupPeticionesReco)
            marcadores.current[marker.id] = marker;
            marker.getElement().addEventListener('click', () => {



            })
            HandlerChangueColor(ev.status, ev.id)
            //Editarreco(marcadores.id,marcadores.lat,marcadores.lng,marcadores.status)
            // HanlderChargueFristAnalitic(ev.id, ev.cityId)
        }
        if (!id) {
            nuevoMarcador.current.next({
                id: marker.id,
                lng,
                lat
            });
        }
    }, [])


    useEffect(() => {
        setTimeout(() => {
            if (Recolectores) {
                if (TipoMapa === "City") {
                    
                    Recolectores.map((res, index)=> {
                        if (res.cityId === JSON.parse(localStorage.getItem("Ciudad")).idciudad) {
                            if (!marcadores.current[res.id]) {
                                AgregarMarcador(res, index)
                                test = res
                            }
                        }
                    })

                }else{
                    Recolectores.map((res, index)=> {
                        if (!marcadores.current[res.id]) {
                            AgregarMarcador(res, index)
                            test = res
                        }
                    })
                }
            }
        }, 1000);

    }, [Recolectores, AgregarMarcador])

    // CALL BACK QUE MONITOREA EL MOVIMIENTO
    const actualizarPosicion = useCallback((datosg) => {
        let data = {
            id: datosg.id,
            lng: datosg.lng,
            lat: datosg.lat
        }
        // setisnotmarker(false)
        marcadores.current[datosg.id].setLngLat([datosg.lng, datosg.lat]);
        HandlerChangueColor(datosg.status, datosg.id)
        // Editarreco(datosg.id,datosg.lat,datosg.lng,datosg.status,Recolectores)
        // HanlderChargueFristAnalitic(datosg.id)

        // let pt = turf.point([datosg.lng, datosg.lat]);
    }, [])

    // FUNCION PARA CAMBIO DE CSS DE RECO
    const HandlerChangueColor = (status, id) => {
        switch (status) {
            case "R":
                marcadores.current[id]._element.className = "RecoiconoMapaR mapboxgl-marker mapboxgl-marker-anchor-center Recolectando";
                break;
            case "D":
                marcadores.current[id]._element.className = "RecoiconoMapaD mapboxgl-marker mapboxgl-marker-anchor-center Documentando"
                break;

            case "I":
                marcadores.current[id]._element.className = "RecoiconoMapaI mapboxgl-marker mapboxgl-marker-anchor-center Documentando"
                break;
            default:
                marcadores.current[id]._element.className = "RecoiconoMapa mapboxgl-marker mapboxgl-marker-anchor-center Libre"
                break;
        }
    }

    // EFECTO QUE ESCUCHA EL MOVIMIENTO DEL MARCADOR
    useEffect(() => {
        if (!socket) return;
        socket.on("UpdatedPicker", (marcadores) => {

            actualizarPosicion(marcadores);
        });
    }, [socket]);

    useEffect(() => {
        if (!socket) return;
        socket.on("ActivePickers", (recosEntrentes) => {

            recosEntrentes?.map((res, index) => {
               
                HandlerChangueColor(res.status, res.id)
            })
        });
    }, [socket]);

    // PETICIONES
    const Peticiones = useRef({});
    const AgregarPeticion = (data) => {
        // console.log(data, "MARCADOR PETICION")
        const elp = document.createElement('div');
        elp.className = `
            ${data.status === 'R'
                ?
                'MarcadorPeticionR'
                :
                data.status === 'D'
                    ?
                    'MarcadorPeticionD'
                    :
                    data.status === 'P'
                        ?
                        'MarcadorPeticionP'
                        :
                        'MarcadorPeticion'
            }`;

            const popupPeticionesReco2 = new mapboxgl.Popup({ offset: 25 }).setHTML(
                `
                <div class='ContainerCardRecoMapa'>
                <div class='ContainerImagenRecoMapaPETICION'>
                    <img src=${data.Origen === "ONSITE" ? 'https://web.pktuno.mx/IMG/onsite.png' : 'https://web.pktuno.mx/IMG/sucursal.png' } ></img>
                  </div>
                      <div class='ContainerTextoReco'>
                        <p>${data.cliente}</p>
                        <p>${data.direccion}</p>
                      </div>
                  </div>
                `
            );
        const marcadorpeticiones = new mapboxgl.Marker(elp);
        marcadorpeticiones.id = data.id
        marcadorpeticiones
            .setLngLat(data.cords)
            .addTo(mapa.current)
            .setPopup(popupPeticionesReco2)
        Peticiones.current[marcadorpeticiones.id] = marcadorpeticiones;
    }

    const AgregarSucursal = async(data) =>{
        const elp = document.createElement('div');
        elp.className = 'SucursalesIconMapa';
        const SucursalesIConMap = new mapboxgl.Marker(elp);
        SucursalesIConMap.id = data.id
        SucursalesIConMap
            .setLngLat([data.longitud,data.latitud])
            .addTo(mapa.current)
           
        SucursalesIcon.current[SucursalesIConMap.id] = SucursalesIConMap;
    }


    useEffect(() => {
        setTimeout(() => {
            let arraypeticiones = new Array;
            if (PeticionesMapa) {
                PeticionesMapa?.map((res, index) => {
                    if (!Peticiones.current[res.id]) {
                        if (res.estatus !== "T" && res.estatus !== "C") {
                            let dt = {
                                id: res.id,
                                cords: [res.coordenadas.longitude, res.coordenadas.latitude],
                                status: res.estatus,
                                Origen: res.origen,
                                idRecolectorAsignado: res.idusuarioasignado,
                                cliente: res.cliente,
                                direccion: res.direccion,
                                fecha: res.fecha
                            }
                            arraypeticiones.push(dt)
                        }
                        arraypeticiones.map(Peticionesex => {
                            if (!Peticiones.current[Peticionesex.id]) {
                                AgregarPeticion(Peticionesex, index)
                            }
                        })
                    }
                })
            }
        }, 1000);

    }, [PeticionesMapa, AgregarPeticion])


    useEffect(() => {
        setTimeout(() => {
            let ArraySucMapa = new Array;
            if (Sucursales) {
                // let SucursalCiudad = Sucursales?.filter(datos => datos.idciudad === JSON.parse(localStorage.getItem("Ciudad")).idciudad)
                Sucursales?.map((res, index) => {
                   if (!SucursalesIcon.current[res.id]) {
                    AgregarSucursal(res)
                    // let dt = {
                    //     id: res.id,
                    //     cords: [res.longitud, res.latitud],
                    //     nombre: res.nombre,
                    // }
                    // ArraySucMapa.push(dt)
                   }
                })
            }
        }, 1000);

    }, [Sucursales, AgregarSucursal])

    // EFECTO QUE ESCUCHA LAS ACTUALIZACIONES DE PETICION
    useEffect(() => {
        if (!socket) return;
        socket.on('UpdateStatusPetition', (data) => {
           
            actualizarPeticion(data)

        })
    }, [socket])

    // FUNCION PARA ACTUALIZAR UNA PETICION
    const actualizarPeticion = (datosg) => {

        switch (datosg.estatus) {
            case "P":
                Peticiones.current[datosg.id]._element.className = "MarcadorPeticionP mapboxgl-marker mapboxgl-marker-anchor-center"
                break;
            case "A":
                Peticiones.current[datosg.id]._element.className = "MarcadorPeticion mapboxgl-marker mapboxgl-marker-anchor-center"
                break;
            case "R":
                Peticiones.current[datosg.id]._element.className = "MarcadorPeticionR mapboxgl-marker mapboxgl-marker-anchor-center"
                break;
            case "D":
                Peticiones.current[datosg.id]._element.className = "MarcadorPeticionD mapboxgl-marker mapboxgl-marker-anchor-center"
                break;
            case "T":
                Peticiones.current[datosg.id].remove()
                break;
            case "C":
                Peticiones.current[datosg.id].remove()
                break;
            default:
                Peticiones.current[datosg.id]._element.className = "MarcadorPeticion mapboxgl-marker mapboxgl-marker-anchor-center"
                break;
        }
        // HandlerChangueColor(datosg.status, datosg.usuarioasignado)
        // HandleEditRecoPetitonCOLOR(datosg.usuarioasignado,datosg.estatus)
        // HandleEditRecoPetiton(datosg.usuarioasignado, datosg.status === "A" ? "L" : datosg.status, RecolectoresMapa === undefined ? test : RecolectoresMapa)
    }


    // RUTAS
    useEffect(() => {
        if (rutareco) {
            if (mapa.current.getLayer('LineString')) {
                mapa.current.removeLayer('LineString')
                mapa.current.removeSource('LineString')
            }
            const geojson = {
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'LineString',
                            'properties': {},
                            'coordinates': rutareco.routes[0].geometry.coordinates
                        }
                    }
                ]
            };

            mapa.current.addSource('LineString', {
                'type': 'geojson',
                'data': geojson
            })
            mapa.current.addLayer({
                'id': 'LineString',
                'type': 'line',
                'source': 'LineString',
                'layout': {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                'paint': {
                    'line-color': rutaencurso.estatus === "A" ? '#3BAF2A' : rutaencurso.estatus === "R" ? '#FFB531' : rutaencurso.estatus === "D" ? '#35C1ED' : '#3BAF2A',
                    'line-width': 5
                }
            });

        }

    }, [rutareco])



    useEffect(() => {
        if (Recolectorselecionado) {

        } else {
            if (mapa.current.getLayer('LineString')) {
                mapa.current.removeLayer('LineString')
                mapa.current.removeSource('LineString')
            }
        }
    }, [rutareco, Recolectorselecionado, mapa.current])

 // Cuando se mueve el mapa
 useEffect(() => {

    mapa.current?.on('move', () => {
        const { lng, lat } = mapa.current.getCenter();
        setCoords({
            lng: lng.toFixed(4),
            lat: lat.toFixed(4),
            zoom: mapa.current.getZoom().toFixed(2)
        })
    });

},[]);

    // ZONAS
    useEffect(() => {
        let geocercadata;
        if (DataZonaUsuario) {

            DataZonaUsuario?.map(responsecords => {
                if (mapa.current.getSource(responsecords.observaciones)) {
                    mapa.current.removeLayer(responsecords.observaciones)
                    mapa.current.removeSource(responsecords.observaciones)
                }
                let Arraygeocerca = new Array(responsecords.cords)
                let ObjGeocerca = JSON.parse(Arraygeocerca[0]);
                const cordenadas = ObjGeocerca.map(resto => { return resto });
                geocercadata = turf.polygon(cordenadas);
                // setgeoJsonZona(geocercadata.geometry)
                mapa.current.addSource(responsecords.observaciones, {
                    "type": "geojson",
                    "data": {
                        "type": "Feature",
                        "geometry": geocercadata.geometry
                    }
                })
                mapa.current?.addLayer({
                    'id': responsecords.observaciones,
                    'type': 'fill',
                    'source': responsecords.observaciones, // reference the data source
                    'paint': {
                        'fill-color': responsecords.color, // blue color fill
                        'fill-opacity': 0.5
                    },
                    'filter': ['==', '$type', 'Polygon']
                });
                mapa.current?.on('click', responsecords.observaciones, (e) => {
                    if (iszonaclick === false) {
                        setiszonaclick(true)
                    } else {
                        setiszonaclick(false)
                    }
                });
            })
        }
    }, [DataZonaUsuario])



    // FUNCION DE POSISIONAR  RECO
    useEffect(() => {
        if (Recolectorselecionado) {
            mapa.current?.flyTo({ zoom: Recolectorselecionado.status != "L" || Recolectorselecionado.status != "I" ? 13 : 18, center: [Recolectorselecionado.lng, Recolectorselecionado.lat], })
        } else {
            mapa.current?.flyTo({ zoom: Zoom, center: [puntoinicial.lng, puntoinicial.lat], })
        }

    }, [Recolectorselecionado])

    // console.log(Recolectorselecionado,"Recolectorselecionado")


    return {
        setRef,
        AgregarMarcador,
        cordsdata,
        // ActivarBotonesNuevaZona
        // geoJsonZona
    }
}

export default UsemapMonitor